<template>
<e-chart ref="chart" />
</template>

<script>
import {AXIS_LABEL, AXIS_LINE_STYLE, NUMBER_FONT_FAMILY} from './FactorCharts/chartStyle'
export default {
  name: 'AQISequentialChart',
  props: {
    data: {
      required: true,
      type: Object
    }
  },
  methods: {
    render (isReal) {
      let {data: {xAxis, series}} = this

      let chartOpt = {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          itemGap: 20,
          textStyle: {
            fontSize: 14
          },
          selectedMode: 'single'
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          },
          right: 10
        },
        grid: [{
          top: 50,
          right: 140,
          bottom: 50,
          left: 50,
          containLabel: true
        }],
        xAxis: {
          type: 'category',
          data: xAxis
        },
        yAxis: {
          type: 'value',
          max: val => {
            return Number(val.max + 30).toFixed(0)
          },
          nameGap: 10,
          axisLine: {
            show: true,
            lineStyle: AXIS_LINE_STYLE
          },
          splitLine: {
            show: true
          },
          axisLabel: {
            ...AXIS_LABEL,
            fontFamily: NUMBER_FONT_FAMILY
          }
        },
        visualMap: {
          top: 50,
          right: 10,
          pieces: [{
            gt: 0,
            lte: 50,
            color: '#00EE00'
          }, {
            gt: 50,
            lte: 100,
            color: '#FFFF00'
          }, {
            gt: 100,
            lte: 150,
            color: '#FF7E00'
          }, {
            gt: 150,
            lte: 200,
            color: '#FF0000'
          }, {
            gt: 200,
            lte: 300,
            color: '#99004C'
          }, {
            gt: 300,
            color: '#7E0024'
          }],
          outOfRange: {
            color: '#999'
          }
        },
        dataZoom: [{
          type: 'inside',
          start: 0,
          end: 100,
          realtime: true,
          xAxisIndex: 0,
          minSpan: 5
        }, {
          type: 'slider',
          start: 0,
          end: 100,
          realtime: true,
          xAxisIndex: 0,
          minSpan: 5,
          // height: 39,
          bottom: 9,
          left: 'center',
          handleIcon: 'M10.7,11.9H9.3c-4.9,0.3-8.8,4.4-8.8,9.4c0,5,3.9,9.1,8.8,9.4h1.3c4.9-0.3,8.8-4.4,8.8-9.4C19.5,16.3,15.6,12.2,10.7,11.9z M13.3,24.4H6.7V23h6.6V24.4z M13.3,19.6H6.7v-1.4h6.6V19.6z',
          handleSize: '70%',
          handleStyle: {
            color: '#fff',
            shadowBlur: 4,
            shadowColor: 'rgba(0, 0, 0, 0.15)',
            shadowOffsetX: 2,
            shadowOffsetY: 2
          },
          // dataBackground: {
          //   areaStyle: '#E4F0FF'
          // }
          fillerColor: 'rgba(228, 240, 255, .6)',
          borderColor: '#E4F0FF'
        }],
        series: series
      }
      // console.log(chartOpt)

      this.$refs.chart.setOpt(chartOpt)
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Data/AQISequentialChart.vue